export const campaignsUpdateCurrentShowIndex = 'CAMPAIGNS/UPDATE_CURRENT_SHOW_INDEX';